import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Popover, Overlay, Button } from 'react-bootstrap';
import browserImageSize from 'browser-image-size';
import Select from 'react-select';
import SpinLoader from '../SpinLoader';
import BlitzAPI from '../../../api/BlitzAPI';
import { EDITOR_IMAGE_OPTIONS } from '../constants';


export default class EditorImageControls extends Component {
  constructor(props) {
    super(props);
    this.togglePopover = this.togglePopover.bind(this);
    this.onFileUpload = this.onFileUpload.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onUrlChange = this.onUrlChange.bind(this);
    this.onCaptionChange = this.onCaptionChange.bind(this);
    this.state = {
      show: false,
      url: '',
      caption: '',
      style: 'regular',
      alt: '',
      loading: false,
    };
  }

  onFileUpload(e) {
    const formData = new FormData();
    formData.append('file', e.target.files[0]);
    this.setState({ loading: true });
    BlitzAPI.postEntryImage(formData).then(
      (response) => {
        this.setState({
          url: response.data.image_url,
          loading: false,
        });
      },
    );
  }

  onUrlChange(e) {
    this.setState({
      url: e.target.value,
    });
  }

  onCaptionChange(e) {
    this.setState({
      caption: e.target.value,
    });
  }

  onSubmit(e) {
    const { url, caption, style, alt } = this.state;
    if (url) {
      browserImageSize(url).then(
        size => this.props.onImageAdd(url, caption, style, alt, size),
      );
    }
  }

  togglePopover(e) {
    e.preventDefault();
    const { editorState } = this.props;
    if (editorState) {
      this.setState({
        show: !this.state.show,
      });
    }
  }

  render() {
    const { container } = this.props;
    const { loading, show, url, caption, alt, style } = this.state;

    return (
      <div className="entry-editor-controls entry-editor-controls-single">
        <div className="entry-editor-styleButton" onClick={this.togglePopover}>
          <img className="fit-parent" src="/assets/img/icons/editor/image.svg" role="presentation" />
        </div>
        <Overlay
          container={container}
          show={show}
          onHide={() => this.setState({ show: false })}
          placement="top"
          target={() => this.linkButton}
          rootClose
        >
          <Popover title="Add an image" id="link-creator-field">
            <div className="popover-image-section-container">
              <div className="popover-image-section">
                <div className="popover-image-url">
                  <label htmlFor="url">Image URL</label>
                  <input
                    type="url" name="url"
                    value={url} onChange={this.onUrlChange}
                    onKeyDown={this.onKeyDown}
                    disabled={loading}
                  />
                </div>
                <div className="popover-image-upload">
                  <label htmlFor="file">Upload Image</label>
                  <input
                    type="file" name="file"
                    onChange={this.onFileUpload}
                    disabled={loading}
                  />
                </div>
                {loading && <SpinLoader />}
              </div>
              <div className="popover-image-section">
                <div className="popover-image-caption">
                  <label htmlFor="caption">Caption</label>
                  <input
                    type="text" name="caption"
                    value={caption} onChange={this.onCaptionChange}
                    disabled={loading}
                  />
                </div>
                <div className="popover-image-alt">
                  <label htmlFor="alt">Alt Text</label>
                  <input
                    type="text" name="alt"
                    value={alt} onChange={e => this.setState({ alt: e.target.value })}
                    disabled={loading}
                  />
                </div>
              </div>
            </div>
            <label htmlFor="style">Style</label>
            <Select
              name="style"
              value={style}
              options={EDITOR_IMAGE_OPTIONS}
              onChange={val => this.setState({ style: val.value })}
            />
            <Button type="button" onClick={this.onSubmit} disabled={loading}>Add Image</Button>
          </Popover>
        </Overlay>
      </div>
    );
  }
}

EditorImageControls.propTypes = {
  container: PropTypes.object,
  editorState: PropTypes.object,
  onImageAdd: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/cms/form/editor/EditorImageControls.js